import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { getListCard, getTrackingLink } from "../../services/CardService";
import { getProPropose } from "../../services/productProposeService";
import check from "../../assets/icons/mdi_check.svg";
import star from "../../assets/icons/5-star-ic.svg";
import creaditCartRed from "../../assets/images/tpbank_red.png";
import creaditCartBlue from "../../assets/images/tpbank_blue.png";
import creaditCartPurple from "../../assets/images/tpbank_purple.png";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { toast } from "react-toastify";

const FALLBACK_CARD_IMAGES = [
  creaditCartRed,
  creaditCartBlue,
  creaditCartPurple,
];

function ExclusiveOffer() {
  const { cardId } = useParams(); // dùng để loại bỏ card đang xem
  const [cardsByLocation, setCardsByLocation] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  const DEFAULT_HEADERS = { "Content-Type": "application/json" };

  const formatCurrencyVND = (value) => {
    if (!value && value !== 0) return "Đang cập nhật";
    if (typeof value === "number")
      return `${value.toLocaleString("vi-VN")} VNĐ`;
    const numeric = Number(value);
    return !isNaN(numeric)
      ? `${numeric.toLocaleString("vi-VN")} VNĐ`
      : "Đang cập nhật";
  };

  const extractCardList = (payload) => {
    if (Array.isArray(payload)) return payload;
    if (Array.isArray(payload?.data?.content)) return payload.data.content;
    if (Array.isArray(payload?.data)) return payload.data;
    if (Array.isArray(payload?.content)) return payload.content;
    return [];
  };

  const parseBenefits = (benefits = []) =>
    Array.isArray(benefits) ? benefits.filter(Boolean) : [];

  const convertFuturesCardCode = (code) => {
    const map = {
      PDC: "Tỷ lệ phê duyệt cao",
      CTO: "Chi tiêu Online",
      RT: "Rút tiền",
    };
    return map[code] || code;
  };

  const fetchData = async () => {
    try {
      setIsLoading(true);

      // 1️⃣ Lấy propose
      const proposeRes = await getProPropose(DEFAULT_HEADERS, {
        productId: cardId,
      });

      const propose = proposeRes?.data;

      if (!propose) {
        setCardsByLocation({});
        return;
      }

      const locations = [
        { key: "location1", ids: propose.location1 || [] },
        { key: "location2", ids: propose.location2 || [] },
        { key: "location3", ids: propose.location3 || [] },
      ];

      // 2️⃣ Lấy danh sách thẻ
      const listRes = await getListCard(DEFAULT_HEADERS, {
        displayStreamCode: "DS04",
        status: true,
      });
      const allCards = extractCardList(listRes?.data);

      // 3️⃣ Nhóm thẻ theo location
      const groupedCards = {};

      for (let loc of locations) {
        const filtered = allCards.filter((card) =>
          loc.ids.includes(card?.registerDeeplink?.id)
        );

        // Lấy tracking link cho từng thẻ
        const cardsWithLinks = await Promise.all(
          filtered.map(async (card) => {
            const id = card?.id || card?.cardId || card?.cardCode || card?.code;
            if (!id || !card?.registerDeeplink?.link) return card;

            try {
              const trackRes = await getTrackingLink(DEFAULT_HEADERS, id);
              const data = trackRes?.data;
              const matched = Array.isArray(data)
                ? data.find((x) => x.link === card.registerDeeplink.link)
                : null;

              if (matched?.linkAff) {
                return {
                  ...card,
                  registerDeeplink: {
                    ...card.registerDeeplink,
                    link: matched.linkAff,
                  },
                };
              }
            } catch (err) {
              console.error(`Tracking link error for card ${id}`, err);
            }

            return card;
          })
        );

        groupedCards[loc.key] = cardsWithLinks;
      }

      setCardsByLocation(groupedCards);
    } catch (err) {
      console.error(err);
      toast.error("Không thể tải dữ liệu. Vui lòng thử lại.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [cardId]);

  const CardProduct = ({ card, index }) => {
    const cardName =
      card?.registerDeeplink?.name ?? card?.name ?? "Thẻ tín dụng";
    const tagLine = card?.registerDeeplink?.tag ?? "Ưu đãi hấp dẫn";
    const maxLimitRaw = card?.registerDeeplink?.limit;
    const maxLimit = formatCurrencyVND(maxLimitRaw) || "Đang cập nhật";
    const giftRaw = card?.registerDeeplink?.gift;
    const gift = formatCurrencyVND(giftRaw) || "Đang cập nhật";
    const annualFeeRaw = card?.registerDeeplink?.annualFee;
    const annualFee = formatCurrencyVND(annualFeeRaw) || "Đang cập nhật";
    const imageSrc =
      card?.registerDeeplink?.imgProduct ||
      FALLBACK_CARD_IMAGES[index % FALLBACK_CARD_IMAGES.length];
    const cardId = card?.id;
    const detailUrl =
      card?.registerDeeplink?.detailUrl ??
      card?.registerDeeplink?.url ??
      (cardId
        ? `/dich-vu/mo-the/card-info/${cardId}`
        : "/dich-vu/mo-the/card-info");
    const applyUrl = card?.registerDeeplink?.link;
    const benefitsRaw = parseBenefits(card?.registerDeeplink?.futuresCard);
    const benefits = benefitsRaw.map((benefit) =>
      convertFuturesCardCode(benefit)
    );

    // Lấy tối đa 3 phần tử, nếu thiếu thì để trống
    const displayBenefits = benefits.slice(0, 3);

    const cardKey =
      card?.id ??
      card?.cardId ??
      card?.cardCode ??
      card?.code ??
      card?.slug ??
      index;
    const isExternalDetail =
      typeof detailUrl === "string" && detailUrl.startsWith("http");

    const applyButtonProps = applyUrl
      ? {
          onClick: () => {
            if (typeof window !== "undefined") {
              window.open(applyUrl, "_blank", "noopener,noreferrer");
            }
          },
        }
      : {
          "data-bs-target": "#notificationModal",
          "data-bs-toggle": "modal",
        };

    const infoRows = [
      {
        label: "Hạn mức tối đa:",
        value: maxLimit || "Đang cập nhật",
      },
      {
        label: "Quà tặng:",
        value: gift || "Đang cập nhật",
      },
      {
        label: "Ưu đãi phí thường niên:",
        value: annualFee || "Đang cập nhật",
      },
    ];

    return (
      <div className="col-sm-4 product offer-card">
        <div className="img-product">
          <img src={imageSrc} alt={cardName} className="card-image" />
        </div>

        <div className="content-product">
          <div className="title-product">
            <h3 className="name-product">{cardName}</h3>
            <span className="tag">
              <img src={star} alt="star" className="star" /> {tagLine}
            </span>
          </div>
          <div className="price-product">
            {infoRows.map((info, infoIndex) => (
              <div className="price-info" key={`${cardKey}-info-${infoIndex}`}>
                <span className="text-price">{info.label}</span>
                <span className="highlight">{info.value}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="divier"></div>

        <div className="tieuchi-product">
          {displayBenefits.map((benefit, benefitIndex) => (
            <div
              className="tieuchi-product-item"
              key={`${cardKey}-benefit-${benefitIndex}`}
            >
              <div className="check-icon">
                <img src={check} alt="check" className="check" />
              </div>
              <div className="tieuchi-product-text">{benefit}</div>
            </div>
          ))}
        </div>

        <div className="btn-actions">
          <button className="btn-custom" {...applyButtonProps}>
            Mở thẻ ngay
          </button>
          {isExternalDetail ? (
            <a
              href={detailUrl}
              className="btn-secondary"
              target="_blank"
              rel="noopener noreferrer"
            >
              Tìm hiểu thêm
            </a>
          ) : (
            <Link to={detailUrl} className="btn-secondary">
              Tìm hiểu thêm
            </Link>
          )}
        </div>
      </div>
    );
  };

  // ⭐⭐⭐ THÊM FILTER LOẠI BỎ CARD ĐANG XEM
  const allExclusiveCards = ["location1", "location2", "location3"]
    .flatMap((locKey) => cardsByLocation[locKey] || [])
    .filter((c) => String(c?.id) !== String(cardId)); // <-- loại bỏ card hiện tại

  return (
    <section className="card-endow-section">
      <div className="container">
        <h2 className="card-endow-title">
          Ưu đãi độc quyền khác của Blue-zone
        </h2>
        <p className="card-endow-description">
          Khám phá thêm các sản phẩm phù hợp với bạn!
        </p>

        {isLoading ? (
          <div className="text-center">Đang tải dữ liệu...</div>
        ) : allExclusiveCards.length === 0 ? (
          <div className="text-center">Không có ưu đãi khác</div>
        ) : (
          <Slider
            dots={false}
            infinite={true}
            speed={1000}
            slidesToShow={3}
            autoplay={true}
            autoplaySpeed={3000}
            responsive={[
              { breakpoint: 1024, settings: { slidesToShow: 2 } },
              { breakpoint: 768, settings: { slidesToShow: 1 } },
            ]}
          >
            {allExclusiveCards.map((card, index) => (
              <CardProduct
                key={
                  card?.id ??
                  card?.cardId ??
                  card?.cardCode ??
                  card?.code ??
                  card?.slug ??
                  index
                }
                card={card}
                index={index}
              />
            ))}
          </Slider>
        )}
      </div>
    </section>
  );
}
export default ExclusiveOffer;
